import type { CommunityRole } from '~/interfaces/community/role';

type RoleBadgeCopy = {
  shortKey: string;
  labelKey: string;
};

export const ROLE_BADGES = {
  admin: {
    shortKey: 'community.roles.admin_short',
    labelKey: 'community.roles.admin',
  },
  manager: {
    shortKey: 'community.roles.manager_short',
    labelKey: 'community.roles.manager',
  },
  moderator: {
    shortKey: 'community.roles.moderator_short',
    labelKey: 'community.roles.moderator',
  },
} as const satisfies Record<CommunityRole, RoleBadgeCopy>;

const ROLE_RANK = ['admin', 'manager', 'moderator'] as const satisfies readonly CommunityRole[];

export const findHighestRole = (roles: CommunityRole[]): CommunityRole | undefined =>
  ROLE_RANK.find((role) => roles.includes(role));
